import React, { Component, Fragment } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import {
    Edit,
    SelectArrayInput,
    SelectInput,
    showNotification,
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'
import {
    TextInput,
    ReferenceSelectInput
} from '../Inputs'
import { booleanChoice } from '../Usuario/data.js'
import ButtonsEditToolbar from '../Usuario/ButtonsEditToolbar'


class UsuarioCoordinadoEditClass extends Component {
  render () {
    const { permissions } = this.props
    if (permissions === null) {
        return null
    }
    // const role = permissions.role
    return (
      <Fragment>
        <Title title={"Editar Usuario"} />
        <Edit {...this.props}>
          <CustomSimpleForm toolbar={<ButtonsEditToolbar { ...this.props }/>}>
          <Field
            name={"username"}
            type="text"
            label={'Username'}
            required={true}
            component={TextInput}
            disabled={true}
          />
          <Field
            name={"email"}
            type="text"
            label={'email'}
            required={true}
            component={TextInput}
          />
          <Field
            name={"first_name"}
            type="text"
            label={'Nombre'}
            required={true}
            component={TextInput}
          />
          <Field
            name={"last_name"}
            type="text"
            label={'Apellido'}
            component={TextInput}
          />
          <Field
            name={"empresa"}
            label={"Empresa"}
            required={true}
            component={ReferenceSelectInput}
            reference={"empresas"}
            isDisabled={false}
          />
          <SelectArrayInput 
            label="Permisos" 
            source="permissions" 
            choices={[
                { id: 'read', name: 'Ver' },
                { id: 'edit', name: 'Editar' },
            ]} 
          />
          <SelectInput
            label="Estado del usuario"
            source="is_active"
            choices={booleanChoice}
          />
          </CustomSimpleForm>
        </Edit>
      </Fragment>
    )
  }
}

const enhance = compose(
    connect( null, { showNotification }),
    reduxForm({
        form: 'redux-form'
    })
)

export const UsuarioCoordinadoEdit = enhance(UsuarioCoordinadoEditClass)

